

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './producthome.css';


const HomeProducts = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('/data/products.json');
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setProducts(data.slice(0, 5)); // Limit to first 5 products
      } catch (err) {
        console.error('Error fetching products:', err);
      }
    };
    fetchData();
  }, []);

  const handleCardClick = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <div className="home-products" id='products'>
      <h2 className="section-title">Our Products</h2>
      <p className="section-subtitle">That make Satvic living simple</p>
      <div className="product-slider">
        {products.map((product) => (
          <div
            key={product.id}
            className="product-card"
            onClick={() => handleCardClick(product.id)}
          >
            <div className="product-card-inner">
              <div className="product-card-front">
                <img
                  src={`/data/${product.images[0]}`}
                  alt={product.name}
                  className="product-img"
                  loading="lazy"
                />
              </div>
              <div className="product-card-back">
                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-price"> 
                    <span className='oldPrice'>₹{product.price}</span>
                    <span className='finalPrice'>₹{product.discountPrice}</span>
                                  </p>
                </div>
                <button className="buy-ebook-btn">View Product &rarr;</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <button className="view-all-btn" onClick={() => navigate('/product')}>See All Products</button>
    </div>
  );
};

export default HomeProducts;